<div class="container">
  <div class="row">
      <div class="col-12">

              <div class="advanced-search col-lg-12"
              [ngClass]="!hideAdvanceFilters ? '': 'collapse'"
               id="advanced-search">
                <div class="card card-body">
                  <div class="form-row">
                    <div class="form-group col-sm-4 text-left">
                      <div>
                        <label>Salary Type</label>
                      </div>
                      <div>
                        <button type="button" class="btn btn-outline-warning btn-sm"
                          [ngClass]="salaryType.id == advanceFilter.salaryType? 'selected-type': ''"
                          (click)="setSelectedType(salaryType.id, filterTypes.SalaryType)"
                          *ngFor="let salaryType of lookUpStore.salaryTypes | async | sortBy: 'desc':'id'">
                          {{salaryType.value}}
                        </button>
                      </div>
                    </div>
                    <div class="form-group col-sm-4 text-left pr-5">
                      <label>Job Type</label>
                      <select class="form-control select-element" #jobType
                        (change)="setSelectedType(jobType.value, filterTypes.JobType)">
                        <option *ngFor="let jobType of lookUpStore.jobTypes | async | sortBy: 'asc':'value'"
                         [value]="jobType.id">{{jobType.value}}</option>
                      </select>
                    </div>
                    <div class="form-group col-sm-4 text-left">
                      <div>
                        <label>Work Type</label>
                      </div>
                      <div>
                        <button type="button" class="btn btn-outline-warning btn-sm"
                          *ngFor="let locationType of locationTypeLookup | sortBy: 'asc':'value'"
                          [ngClass]="advanceFilter.workType == locationType.id ? 'selected-type': ''"
                          (click)="setSelectedType(locationType.id, filterTypes.WorkType)">
                          {{locationType.value}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      </div>
  </div>
</div>
